function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "user"
}, React.createElement("rect", {
  id: "\xE7\x9F\xA9\xE5\xBD\xA2",
  opacity: 0.01,
  width: 20,
  height: 20,
  fill: "white"
}), React.createElement("path", {
  id: "\xE5\xBD\xA2\xE7\x8A\xB6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1934 12.5801C15.8672 13.2539 16.3985 14.0391 16.7676 14.9141C17.1309 15.7715 17.3243 16.6797 17.3438 17.6133C17.3457 17.7012 17.2754 17.7734 17.1875 17.7734H16.0157C15.9297 17.7734 15.8614 17.707 15.8594 17.6211C15.8204 16.1133 15.2149 14.7012 14.1446 13.6309C13.0371 12.5234 11.5664 11.9141 10 11.9141C8.43363 11.9141 6.96293 12.5234 5.85551 13.6309C4.7852 14.7012 4.17973 16.1133 4.14066 17.6211C4.13871 17.7051 4.07035 17.7734 3.98441 17.7734H2.81254C2.72465 17.7734 2.65434 17.7012 2.65629 17.6133C2.67582 16.6797 2.86918 15.7715 3.23246 14.916C3.60356 14.041 4.13285 13.2559 4.80668 12.582C5.48051 11.9062 6.26566 11.377 7.14066 11.0078C7.14457 11.0059 7.14848 11.0044 7.15238 11.0029C7.15629 11.0015 7.1602 11 7.1641 10.998C5.94731 10.1172 5.15629 8.68555 5.15629 7.07031C5.15629 4.39453 7.32426 2.22656 10 2.22656C12.6758 2.22656 14.8438 4.39453 14.8438 7.07031C14.8438 8.68555 14.0528 10.1172 12.836 10.9961C12.8399 10.998 12.8438 10.9995 12.8477 11.001C12.8516 11.0024 12.8555 11.0039 12.8594 11.0059C13.7344 11.377 14.5196 11.9062 15.1934 12.5801ZM7.62504 9.44531C8.25981 10.0801 9.10356 10.4297 10 10.4297C10.8965 10.4297 11.7403 10.0801 12.375 9.44531C13.0098 8.81055 13.3594 7.9668 13.3594 7.07031C13.3594 6.17383 13.0098 5.33008 12.375 4.69531C11.7403 4.06055 10.8965 3.71094 10 3.71094C9.10356 3.71094 8.25981 4.06055 7.62504 4.69531C6.99027 5.33008 6.64066 6.17383 6.64066 7.07031C6.64066 7.9668 6.99027 8.81055 7.62504 9.44531Z",
  fill: "white"
}));

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/List.eaef1b3d.svg";
export { ForwardRef as ReactComponent };